import { ExpandIcon } from '@libs/ui/ds/assets/icons'
import type { FC } from 'react'

import { IconWrap } from '../../../../dataDisplay/IconWrap/base/IconWrap'

export const AnchorLinkIcon: FC = () => {
  return <IconWrap className='ml-0.5 inline' size='s' icon={<ExpandIcon />} />
}
